export default __webpack_public_path__ + "static/media/cobros-particulares-y-seguros.9ac8ce3f.svg";